import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'
import taiChiMoveFWebp from '@/assets/landing/tai-chi-move-f.webp'

const schema: LandingScreenSchema = {
	config: {
		background: 'transparent',
	},
	order: [
		'LandingBackgroundImage',
		'LandingHead',
		'LandingTitleMove',
		'LandingComponentSpacer',
		'LandingProgressLoader',
		'LandingFooter',
	],
	components: {
		LandingBackgroundImage: (): LandingComponentsConfig['LandingBackgroundImage'] => ({
			image: taiChiMoveFWebp,
			// Anchor to top so Master Lee's face isn't cropped on short/wide viewports.
			position: 'top',
		}),
		LandingHead: (): LandingComponentsConfig['LandingHead'] => ({
			logoAlignment: 'center',
			logoColor: 'white',
			logo: 'move',
		}),
		LandingTitleMove: (): LandingComponentsConfig['LandingTitleMove'] => ({
			// TODO(DEV-33000): хардкод EN до заведения CDN-ключей через L10N (V1 en-only,
			// прецедент Korean Glow Diet 49bc50445)
			title: 'Your Tai Chi Plan<br/>with Master Lee',
		}),
		LandingProgressLoader: (): LandingComponentsConfig['LandingProgressLoader'] => ({
			duration: 3500,
			theme: 'white',
		}),
		LandingFooter: (): LandingComponentsConfig['LandingFooter'] => ({
			textColor: 'white',
		}),
	},
}

export default schema
